import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
/**
 * Quick Button
 */
const Popular = ({ boxStyle, item, viewType, onClickEvt }) => {
  const { items, id, type } = item;
  return (
    <>
      <div className="_list_button_div" style={{float:"left"}} >
        {items !== undefined &&
          items.map((tempItem, idx) => {
            console.log(tempItem)
            return (
            <div className="_list_button_area" key={`${id}_${idx}_area`}>
              <div key={`${id}_${idx}`} className="_button" style={boxStyle} onClick={e => onClickEvt(tempItem.text.desc, 'query')}>
                {idx+1+". "}{ReactHtmlParser(tempItem.text.desc)}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};
Popular.propTypes = {
  boxStyle: PropTypes.object,
  item: PropTypes.object,
  viewType: PropTypes.string,
  onClickEvt: PropTypes.func,
};
Popular.defaultProps = {
  boxStyle: {},
  item: {},
  viewType: 'advise', // advise, simulator, knowledge
  onClickEvt: null,
};

export default Popular;
